import React, { createRef, useReducer, useRef } from "react";
import BasicInfo from "./BasicInfo/BasicInfo";
import WhatsIncluded from "./WhatsIncluded/WhatIncluded";
import Location from "./Location/Location";
import PageLayout from "../PageLayout/PageLayout";
import { useSelector } from "react-redux";

export default function EditLesson() {
  const activeTab = useSelector((state) => state.commonReducer.activeTab);

  return (
    <>
      <PageLayout>
        {(activeTab == "basic-info" && <BasicInfo />) ||
          (activeTab == "whats-included" && <WhatsIncluded />) ||
          (activeTab == "location" && <Location />)}
      </PageLayout>
    </>
  );
}
